<template>
  <div
    v-if="
      (param === 'layout.grid.columns' && optionEnabled === true) || param !== 'layout.grid.columns'
    "
    class="control"
    :class="{
      indent: [
        'video.controls.volume',
        'video.controls.speed',
        'video.controls.quality',
        'video.controls.playbar',
      ].includes(parameter),
    }"
  >
    <div class="control__title">
      <div class="title">
        <div class="title-text">
          {{ title }}
        </div>
        <div class="control__helper">
          <div class="control__trigger" @mouseover="showHint = true" @mouseleave="showHint = false">
            <img src="https://sirv.sirv.com/website/theme2/icon/question.svg" :alt="hint" />
          </div>
          <div v-show="showHint" class="hint">
            {{ hint }}
          </div>
        </div>
      </div>
    </div>
    <div class="control__action">
      <div class="control__choice">
        <div
          class="fakeoverlay"
          :class="{ disabled: !radioStatus }"
          @click="radioStatus = !radioStatus"
        />
        <el-radio
          v-for="(radioValue, index) in radioOption"
          :key="index"
          v-model="value"
          :disabled="!radioStatus"
          :label="radioHasLabel(radioValue)"
          @change="changeOption"
        >
          {{ radioValue.value }}
        </el-radio>
      </div>
      <el-checkbox v-model="radioStatus" class="control__checkbox" @change="changeOption" />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import optionEnabled from "@/store/observable/option-enabled";

export default {
  name: "RadioInline",
  props: {
    title: {
      type: String,
      default: "",
    },
    default: {
      type: [Boolean, String],
    },
    hint: {
      type: String,
      default: "",
    },
    status: {
      type: Boolean,
    },
    options: {
      type: Array,
      default: Function,
    },
    parameter: {
      type: String,
      default: "",
    },
    eventClick: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      value: this.default,
      radioStatus: this.status,
      radioOption: this.options,
      showHint: false,
      param: this.parameter,
    };
  },
  computed: {
    optionEnabled,
    ...mapState(["clearOptions", "zoomEnable"]),
  },
  watch: {
    clearOptions(value) {
      if (value) {
        // this.optionEnabled = [];
        this.radioStatus = false;
        this.value = this.default;
      }
    },
    eventClick(val) {
      this.value = this.default;
      this.radioStatus = val;
    },

    radioStatus(val) {
      if (val == true) {
        this.changeOption();
      }
    },
    value(val) {
      this.changeOption();
    },
    // radioStatus(val) {
    //   this.changeOption();
    //   // if (val == false && this.parameter === "zoom.enable" && this.zoomEnable) {
    //   //   this.$store.dispatch("enableZoom", false);
    //   // }

    //   if (this.parameter === "layout.type") {
    //     this.optionEnabled = val;
    //   }
    // },
  },
  methods: {
    radioHasLabel(radio) {
      return radio.hasOwnProperty("label") ? radio.label : radio.value;
    },
    changeOption() {
      const value = this.radioStatus === true ? `${this.value}` : "";
      this.$emit("changeOption", {
        parameter: `${this.parameter}`,
        separator: ":",
        value: value,
      });
    },
  },
};
</script>
